import Profile from '../pages/User/Profile';
import OrderDelivery from '../pages/User/OrderDelivery';
import AccountSettings from '../pages/User/AccountSettings';
import Deliveries from '../pages/User/Deliveries';
import Home from '../pages/User/Home';
import UserLayout from '../components/layouts/UserLayout';
import DeliveryDetails from '../pages/User/DeliveryDetails';
export const protectedRoutes = [
  {
    path: '/profile',
    element: (
      <UserLayout>
        <Profile />
      </UserLayout>
    )
  },
  {
    path: '/user/home',
    element: (
      <UserLayout>
        <Home />
      </UserLayout>
    )
  },
  {
    path: '/order-delivery',
    element: (
      <UserLayout>
        <OrderDelivery />
      </UserLayout>
    )
  },
  {
    path: '/delivery/:id',
    element: (
      <UserLayout>
        <DeliveryDetails />
      </UserLayout>
    )
  },
  {
    path: '/account-settings',
    element: (
      <UserLayout>
        <AccountSettings />
      </UserLayout>
    )
  },
  {
    path: '/deliveries',
    element: (
      <UserLayout>
        <Deliveries />
      </UserLayout>
    )
  }
];
